
<template>
  <div>
    <dialog-loading v-if="loading" loadingText="Carregando"></dialog-loading>
    <v-dialog 
      v-model="default_dialog" 
      scrollable 
      persistent 
      :fullscreen="fullscreen"
      :max-width="loading ? '500px' : '80%'"
    >
      <v-card v-if="!loading">
        <v-card-title class="d-flex align-center grey lighten-3 grey--text text--darken-3">
          <v-btn icon color="error" @click="goBack" class="mr-2"><v-icon>mdi-close</v-icon></v-btn> 
          <slot name="title"></slot>
          <v-spacer></v-spacer>
          <slot name="right-title"></slot>

        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <slot name="content"></slot>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <slot name="actions"></slot>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

export default {
  name: 'DefaultDialog',
  props:{
    loading:{
      type: Boolean,
      default: false,
    },
    dialog: {
      type: Boolean,
      default: true
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    return_params:{
      type: Boolean,
      default: false,
    }
  },
  data(){
    return{
      default_dialog: false,
    }
  },
  methods:{
    openDialog(){
      if(this.dialog && !this.loading){
        this.default_dialog = true
      }else{
        this.default_dialog = false
      }
    },
    goBack() {
    const matchedRoutes = this.$route.matched;
    if (matchedRoutes.length >= 2) {
      const rotaPai = matchedRoutes[matchedRoutes.length - 2];
      if(this.return_params && this.$route.params.solution){
        return this.$router.push({ name: rotaPai.name, params: {solution: this.$route.params.solution} });
      }
      this.$router.push({ name: rotaPai.name });
    }else{
      this.$router.go(-1)
    }
  }
  },
  watch:{
    loading(){
      this.openDialog()
    },
    dialog(){
      this.openDialog()
    },
  }
}
</script>
